import React from "react";

const JobCard = ({ job, onView, onApply }) => {
    return (
        <div
            className="card mb-4 border"
            style={{
                borderRadius: "9px",
                borderColor: "#cecbcbff",
                borderWidth: "0.5px",
            }}
        >
            <div className="card-body">
                {/* Job Info */}
                <h5 className="fw-bold mb-1 fs-5">
                    {job.c_title}
                </h5>

                <p className="text-muted mb-1 fs-6 ">
                    {job.
                        c_company_name}
                </p>

                <a href="#" className="fs-8 text-primary text-decoration-none">
                    {job.department}
                </a>

                {/* Meta Info */}
                <div className="d-flex gap-4 flex-wrap text-muted fs-7 mt-3">
                    <span><i className="bi bi-briefcase"></i> {job.
                        c_experience
                    }</span>
                    <span><i className="bi bi-geo-alt"></i> {job.c_location
                    }</span>
                    <span><i className="bi bi-clock"></i> {job.c_job_type}</span>
                </div>

                {/* Buttons Bottom */}
                <div
                    className="d-flex gap-3 mt-4"
                    style={{ borderTop: "1px solid #f1f1f1", paddingTop: "16px" }}
                >
                    <button
                        className="btn btn-outline-secondary w-50"
                        onClick={onView}
                        style={{
                            borderRadius: "8px",
                            fontSize: "14px",
                        }}
                    >
                        View Details
                    </button>

                    <button
                        className="btn w-50 text-white"
                        onClick={onApply}
                        style={{
                            backgroundColor: "#ff6a32",
                            borderRadius: "8px",
                            fontSize: "14px",
                        }}
                    >
                        Apply Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JobCard;